import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DateFilters } from '../../../factoring/interface/data.interface';
import { Deptors, RequestMinutes } from '../../interface/company-client.interface';
import { CdkContextMenuTrigger } from '@angular/cdk/menu';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ScoringIngeService } from '../../service/scoring-inge.service';
import { environment } from 'src/environments/enviroments';
import { getMinuteStyleByState } from 'src/app/common/custom-style';

@Component({
  selector: 'app-table-minutes',
  templateUrl: './table-minutes.component.html',
  styleUrls: ['./table-minutes.component.scss'],
})
export class TableMinutesComponent {
  @Input() recieveFilterDate: DateFilters;
  @Input() recieveFilterName: string;
  @Input() minutes: Array<RequestMinutes>;
  @Input() rut: string;
  @Output() viewRegisterMinute: EventEmitter<number> = new EventEmitter();
  @ViewChild(CdkContextMenuTrigger) menu!: CdkContextMenuTrigger;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  public dataSource!: MatTableDataSource<RequestMinutes>;
  public dateElement: Deptors;
  public rutCompany: number;
  public minuteState: string;
  public existenDatos: boolean; 
  public displayedColumns: string[] = [
    'minuteRequestId',
    'minuteState',
    'lineApproved',
    'lineApprovedWarranties',
    'createdAt',
    'dueDate',
  ];

  constructor(private router: Router, private equifaxService: ScoringIngeService) {}

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    const boardDeals: Array<RequestMinutes> = changes['minutes']?.currentValue;
    this.dataSource = new MatTableDataSource<RequestMinutes>(boardDeals);
    if (
      changes['recieveFilterName'] &&
      changes['recieveFilterName'].currentValue !== undefined
    ) {
      this.applyFilter();
    }
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter() {
    const filterValue = this.recieveFilterName!;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openRegisterMinutes(): void {
    this.viewRegisterMinute.emit();
  }

  public redirectMinute(minuteRequestId: number) {
    if(minuteRequestId <= environment.nminutelimitold) 
    {
      this.redirectToOldMinute(minuteRequestId);
    }
    else
    {
      this.redirectToNewMinute(minuteRequestId);
    }
  }

  public redirectToOldMinute(minuteRequestId: number) {
    this.router.navigate(['dashboards/old-minute'], {
      queryParams: { id: +minuteRequestId },
    });
  }

  public redirectToNewMinute(minuteRequestId: number) {
    this.router.navigate(['dashboards/minute'], {
      queryParams: { id: +minuteRequestId },
    });
  }

  public getStateColor(minuteState: string): unknown {
    return getMinuteStyleByState(minuteState);
  }
}
